import { useParams } from "react-router";

import Box from "@mui/material/Box";

import { useTranslation } from "react-i18next";
import Tabs from "../../../components/Tabs";
import BrandingForm from "../../../features/branding/Form";
import BasicInfo from "../../../features/company/BasicInfo";
import GeneralInfo from "../../../features/company/GeneralInfo";
import APIIntegrations from "../../../features/integrations/super-admin";
import SuperAdminStats from "../../../features/statistics/SuperAdminStats";
import { WeeklyPublicationStats } from "../../../features/statistics/SuperAdminStats/WeeklyPublicationStats";

const Company = () => {
	const { t } = useTranslation();
	let { companyId } = useParams();

	const tabs = [
		{
			label: t("general"),
			content: <GeneralInfo companyId={companyId} />,
		},
		{
			label: t("statistics"),
			content: (
				<Box sx={{ display: "flex", flexDirection: "column", gap: "40px" }}>
					<SuperAdminStats companyId={companyId} />
					<WeeklyPublicationStats companyId={companyId} />
				</Box>
			),
		},
		{
			label: t("api"),
			content: <APIIntegrations companyId={companyId} />,
		},
		{
			label: t("branding"),
			content: <BrandingForm companyId={companyId} />,
		},
	];

	return (
		<Box>
			<Box sx={{ mb: 2 }}>
				<BasicInfo companyId={companyId} />
			</Box>
			<Tabs ariaLabel={t("admin_panel")} tabs={tabs} />
		</Box>
	);
};

export default Company;
